import React, { createContext, useState, useContext } from 'react'

const DataContext = createContext()

export const DataProvider = ({children}) => {
  const [data, setData] = useState({});

  const setValues = (values) => {
    setData(prevData => ({
      ...prevData,
      ...values
    }))
  }

  const emptyData = () => {
    if(data.iAMSmart == null || data.iAMSmart == undefined){
      setData({});
    }else{
      setData({iAMSmart: data.iAMSmart});
    }
  }

  return <DataContext.Provider value={{data, setValues, emptyData}}>
    {children}
  </DataContext.Provider>
}

export const useData = () => useContext(DataContext)